import { FETCH_INVOICE, FETCH_INVOICE_FAIL, FETCH_INVOICE_SUCCESS } from '../actions/invoice';

const initialState = {
  isLoading: false,
  invoices: [],
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};

const invoiceReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_INVOICE: {
      return { ...state, isLoading: true };
    }

    case FETCH_INVOICE_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        invoices: payload.results,
        page: payload.page,
        limit: payload.limit,
        totalPages: payload.totalPages,
        total: payload.totalResults,
      };
    }

    case FETCH_INVOICE_FAIL: {
      return { ...state, isLoading: false };
    }

    default:
      return { ...state };
  }
};
export default invoiceReducer;
